import createReactComponent from '../createReactComponent';
export default createReactComponent('brand-blender', 'IconBrandBlender', [
  ['path', { d: 'M15 14m-6 0a6 5 0 1 0 12 0a6 5 0 1 0 -12 0', key: 'svg-0' }],
  ['path', { d: 'M15 14m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0', key: 'svg-1' }],
  ['path', { d: 'M3 16l9 -6.5', key: 'svg-2' }],
  ['path', { d: 'M6 9h9', key: 'svg-3' }],
  ['path', { d: 'M13 5l5.65 5', key: 'svg-4' }],
]);
